import React, { useEffect, useState, useContext } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./personaldetails.css";
import "primeflex/primeflex.scss";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import EditMobile from "./EditMobile";
import EditEmail from "./EditEmail";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Tooltip } from 'primereact/tooltip';
import { Checkbox } from 'primereact/checkbox';
import { Context } from "../../Context/GlobalContext";
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import verified from "../../assets/check-mark.png"
import HourglassTopIcon from '@mui/icons-material/HourglassTop';

const PersonalDetails = ({ msg }) => {
  const { setPersonal, personal } = useContext(Context)
  const [newMobile, setNewMobile] = useState({});
  const [newEmail, setNewEmail] = useState([]);
  const [isDetailsChange, setIsDetailsChange] = useState(false);
  const [error, setError] = useState("");
  const [update, setUpdate] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [showTC, setShowTC] = useState(false);
  const [netWorth, setNetWorth] = useState(personal.netWorth);

  const selectGender = [
    { label: "Select Your Gender", value: "" },
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Transgender", value: "Transgender" },
  ];

  const selectMaritalStatus = [
    { label: "Married", value: "Married" },
    { label: "Single", value: "Single" },
  ];

  const selectIncomeSlab = [
    { label: "Below 5 LAC", value: "Below 5 LAC" },
    { label: "5-10 LAC", value: "5-10 LAC" },
    { label: "10-25 LAC", value: "10-25 LAC" },
    { label: "25-50 LAC", value: "25-50 LAC" },
    { label: " Above 50 LAC", value: " Above 50 LAC" },
  ];

  const TermAndCondition = 'I confirm that the information provided above is true, correct and complete to the best of my knowledge. In case any of the above specified information is found to be false or untrue, I am aware that I may be liable for it. In case of any changes in the above given information on a future date, I undertake to inform Moneywise Finvest Limited (Stoxkart) within 30 Days of such change.'

  const initialValue = {
    gender: personal.userGender,
    maritalStatus: personal.userMaritalStatus,
    motherName: personal.motherName,
    fatherName: personal.fatherName,
    incomeSlab: personal.incomeSlab,
  };
  const initialCheck = {
    isNotPoliticallyExposed: "",
    isIndianCitizen: "",
    isAcceptTnC: "",
    taxResidence:""
  };

  const [check, setCheck] = useState(initialCheck);
  const [user, setUser] = useState(initialValue);
  const {
    gender,
    maritalStatus,
    motherName,
    fatherName,
    incomeSlab,
  } = user;
  const { isNotPoliticallyExposed, isIndianCitizen, isAcceptTnC, taxResidence } = check;
  const navigate = useNavigate();
  const userCode = sessionStorage.getItem("userCode");
  const URL = process.env.REACT_APP_BASE_URL;
 
  const getUserData = async () => {
    try {
      const response = await axios.post(`${URL}/PersonalDetail/getDetails`, {
        userCode: userCode,
      }, { withCredentials: true });
      setPersonal(response.data.data);
      setNetWorth(response.data.data.netWorth)
      setUser(response.data.data);
      setCheck(response.data.data);
    } catch (error) {
      console.log("error in get data", error);
    }
  };
  const savetUserData = async (event) => {
    try {
      if(netWorth?.length == '' || netWorth > 100000 ) {
        await axios.post(`${URL}/PersonalDetail/saveDetails`, {
          userCode: personal.userCode,
          userFullName: personal.userFullName,
          userDOB: personal.userDOB,
          userPAN: personal.userPAN,
          userGender: gender ? gender : personal.userGender,
          userMaritalStatus: maritalStatus ? maritalStatus : personal.userMaritalStatus,
          userMobile: personal.userMobile,
          userEmail: personal.userEmail,
          motherName: motherName,
          fatherName: fatherName,
          incomeSlab: incomeSlab,
          netWorth: netWorth,
          isNotPoliticallyExposed: isNotPoliticallyExposed
            ? isNotPoliticallyExposed
            : personal.isPoliticallyExposed,
          isAcceptTnC: isAcceptTnC ? isAcceptTnC : personal.isAcceptTnC,
          isDetailsChange: isDetailsChange,
          isIndianCitizen: isIndianCitizen
            ? isIndianCitizen
            : personal.isIndianCitizen,
        }, { withCredentials: true });
        setShowMessage(true);
        setUpdate("");
      } else {
        setError('Networth should be greater than 1 lakhs and smaller than 10 crores')
        return;
      }
      
    } catch (error) {
      setError(error.response.data.result.flagMsg);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  const closePopUp = () => {
    setShowMessage(false);
    navigate("/permanent");
  };

  const onValueChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
    setError("");
    setUpdate("Proceed With Updated Details");
  };

  const onValueCheck = (e) => {
    setCheck({ ...check, [e.target.name]: e.target.checked });
    setIsDetailsChange(true);
    setUpdate("Proceed With Updated Details");
  };

  const onAmountChange = e => {
    setError("");
    const {value} = e.target;
    if (!value || value.match(/^\d{1,}(\.\d{0,2})?$/)) {
      setNetWorth(value);
    }
  };

  const openTcDialog = () => {
    setShowTC(true)
  }

  const dialogFooter = (
    <div className="flex justify-content-center">
      <Button
        label="OK"
        className="p-button-raised p-button-sm smc_color"
        autoFocus
        onClick={closePopUp}
      />
    </div>
  );
  const dialogFooterTC = (
    <div className="flex justify-content-center">
      <Button
        label="OK"
        className="p-button-raised p-button-sm smc_color"
        autoFocus
        onClick={()=> setShowTC(false)}
      />
    </div>
  );
  return (
    <>
    
      <Dialog
        visible={showMessage}
        onHide={() => setShowMessage(false)}
        position="top"
        footer={dialogFooter}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <i
            className="pi pi-check-circle"
            style={{ fontSize: "5rem", color: "var(--green-500)" }}
          ></i>
          <h5 className="c_pop">Details Saved Successfully!</h5>
        </div>
      </Dialog>
      <Dialog
        visible={showTC}
        onHide={() => setShowTC(false)}
        position="top"
        footer={dialogFooterTC}
        showHeader={false}
        breakpoints={{ "960px": "80vw" }}
        style={{ width: "30vw" }}
      >
        <div className="flex align-items-center flex-column pt-6 px-3 ">
          <p style={{ fontSize: "1.5rem", color: "var(--green-500)" }}>Terms & Conditions</p>
          <h6 className="c_pop" style={{textAlign: 'justify'}}>{TermAndCondition}</h6>
        </div>
      </Dialog>
      <Card
        style={{
          margin: "0.5em 2em 2em 2em",
          padding: "1em",
          borderRadius: 20,
        }}
      >
        <div className="line">
          
          <h2>
            Personal Details
          </h2>
          {/* <div className="top_msg">

          </div> */}
          <div>
              {msg.personalDetailStatus == "VERIFIED" ?    <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<img src={verified} alt='verify' width='25px' />} label={msg.personalDetailStatus}  variant="outlined" sx={{background: '#0080004f'}} />
              
            
            </div>: msg.personalDetailStatus == "PENDING" ?    <div
              style={{
                fontSize: 12,
                color:'green',
                float: "right",
                marginTop: '-8px',
                // display:'contents'
              }}
            ><Chip icon={<HourglassTopIcon />} label={msg.personalDetailStatus}  variant="outlined" sx={{background: '#d3d3436b'}} />
              
              
            
            </div> : msg.personalDetailStatus == "REJECTED" ?   <div
            style={{
              fontSize: 12,
              color:'red',
              float: "right",
              marginTop: 20,
              display:'contents'
            }}
          >{msg.personalDetailRemarks}</div> : null}
            </div>
          <hr />
        </div>
       <Stack direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }} spacing={2} marginTop='50px'>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>
                Client id:<sup>*</sup>
              </label>
        <InputText
                  className="p-inputtext-sm h-5"
                  value={personal.userCode}
                  disabled
                />
        </Stack>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Name:<sup>*</sup></label>
        <InputText
                  className="p-inputtext-sm h-5"
                  value={personal.userFullName}
                  disabled
                />
        </Stack>
       </Stack>

       <Stack direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }} spacing={2} marginTop='15px'>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Father's name:<sup>*</sup></label>
        <InputText
                  name="fatherName"
                  className="p-inputtext-sm h-5"
                  onChange={(event) => onValueChange(event)}
                  value={fatherName}
                  keyfilter={/^[a-zA-Z ]*$/}
                  maxlength="50"
                  autoComplete="off"
                  disabled={msg.personalDetailStatus == "VERIFIED" || msg.personalDetailStatus == "PENDING"}
                />
        </Stack>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Mother's name:<sup>*</sup></label>
        <InputText
                  name="motherName"
                  onChange={(event) => onValueChange(event)}
                  className="p-inputtext-sm h-5"
                  value={motherName}
                  autoComplete="off"
                  disabled={ msg.personalDetailStatus == "VERIFIED" || msg.personalDetailStatus == "PENDING"  }
                  maxlength="50"
                  keyfilter={/^[a-zA-Z ]*$/}
                />
        </Stack>
       </Stack>

       <Stack direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }} spacing={2} marginTop='15px'>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>PAN:<sup>*</sup></label>
        <InputText
                  className="p-inputtext-sm h-5"
                  value={personal.userPAN}
                  disabled
                />
        </Stack>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>DOB :<sup>*</sup>
        <span style={{fontSize: 10, marginTop: 10}}>(YYYY-MM-DD)</span></label>
        <Calendar
                  className="h-5"
                  dateFormat="dd/mm/yy"
                  placeholder={personal.userDOB}
                  disabled
                />
        </Stack>
       </Stack>

       <Stack direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }} spacing={2} marginTop='15px'>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Marital Status:<sup>*</sup></label>
        <Dropdown
                  className={
                    error == "User Marital Status can't be blank."
                      ? "p-inputtext-sm p-invalid h-5"
                      : "p-inputtext-sm h-5"
                  }
                  value={maritalStatus}
                  name="maritalStatus"
                  options={selectMaritalStatus}
                  onChange={(event) => onValueChange(event)}
                  placeholder={personal.userMaritalStatus ? personal.userMaritalStatus : "Select Your Marital Status" }
                  disabled={msg.personalDetailStatus == "VERIFIED" || msg.personalDetailStatus == "PENDING"}
                />
        </Stack>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Gender:<sup>*</sup></label>
        <Dropdown
                  className={
                    error == "User Gender can't be blank."
                      ? "p-inputtext-sm p-invalid h-5"
                      : "p-inputtext-sm p-valid h-5"
                  }
                  name="gender"
                  value={personal.userGender}
                  options={selectGender}
                  onChange={(event) => onValueChange(event)}
                  placeholder={personal.userGender}
                  disabled
                />
        </Stack>
       </Stack>

       <Stack direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }} spacing={2} marginTop='15px'>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Mobile:<sup>*</sup></label>
        <EditMobile
                  newMobile={newMobile}
                  personal={personal}
                  setPersonal={setPersonal}
                  msg={msg}
                  update={update}
                  setUpdate={setUpdate}
                  disabled={msg.personalDetailStatus == "VERIFIED" || msg.personalDetailStatus == "PENDING"}
                />
        </Stack>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Email:<sup>*</sup></label>
        <EditEmail
                  personal={personal}
                  setPersonal={setPersonal}
                  newEmail={newEmail}
                  setNewEmail={setNewEmail}
                  msg={msg}
                  update={update}
                  setUpdate={setUpdate}
                />
        </Stack>
       </Stack>

       <Stack direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }} spacing={2} marginTop='15px'>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label class="col-fixed" style={{ width: 100 }}>Income Slab:<sup>*</sup></label>
        <Dropdown
                  className="p-inputtext-sm h-5"
                  name="incomeSlab"
                  options={selectIncomeSlab}
                  value={incomeSlab}
                  onChange={(event) => onValueChange(event)}
                  placeholder={
                    personal.incomeSlab
                      ? personal.incomeSlab
                      : "Select Your Income Slab"
                  }
                  disabled={msg.personalDetailStatus == "VERIFIED" || msg.personalDetailStatus == "PENDING"}
                />
        </Stack>
        <Stack direction='row' spacing={2} width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}>
        <label for="Client-id" class="col-fixed" style={{ width: 100 }}>
        Networth :<span style={{fontSize:10}}>(optional)</span>
              </label>
              <InputText
                  name="netWorth"
                  onChange={onAmountChange}
                  className="p-inputtext-sm h-5"
                  value={netWorth}
                  autoComplete="off"
                  keyfilter="num"
                  maxLength= "8"
                  minLength='6'
                  disabled={msg.personalDetailStatus == "VERIFIED" || msg.personalDetailStatus == "PENDING"}
                />       
        </Stack>
       </Stack>
        
        <div className="field-checkbox" style={{ marginTop: 30 }}>
                    <Checkbox 
                    name="isNotPoliticallyExposed"
                    checked={true}
                    value={isNotPoliticallyExposed}
                    onChange={(e) => onValueCheck(e)}
                    disabled
                    />
                    <label htmlFor="binary">I am not a PEP (politically Exposed person) or related to PEP.</label>
                </div>
                <div className="field-checkbox">
                    <Checkbox 
                    name="isIndianCitizen"
              checked={true}
              value={isIndianCitizen}
              onChange={(e) => onValueCheck(e)}
              disabled
                    />
                    <label htmlFor="binary">I am an Indian citizen, born and residing in India.</label>
                </div>
                <div className="field-checkbox">
                    <Checkbox 
                    name="taxResidence"
                    checked={true}
                    value={taxResidence}
                    onChange={(e) => onValueCheck(e)}
                    disabled
                    />
                    <label htmlFor="binary">I am not tax residence of any other country.</label>
                </div>
                <div className="field-checkbox">
                <Tooltip target=".custom-target-icon" />
                    <Checkbox 
                    name="isAcceptTnC"
              checked={isAcceptTnC}
              value={isAcceptTnC}
              onChange={(e) => onValueCheck(e)}
              disabled
                    />
                    <label htmlFor="binary">Accept Terms & Conditions  
                    <i 
                    className="custom-target-icon pi pi-info-circle ml-2" 
                    data-pr-tooltip='Click here to show Terms & Conditions'
                    data-pr-position="right" 
                    data-pr-at="right+5 top" 
                    data-pr-my="left center-2" 
                    style={{ fontSize: '1rem', cursor: 'pointer' }} 
                    onClick={openTcDialog}
                    />
                    </label>
                </div>
        <p style={{ color: "red", fontSize: 12 }}>{error ? error : null}</p>
        <Button
          disabled={
            msg.personalDetailStatus == "VERIFIED" ||
            msg.personalDetailStatus == "PENDING" ||
            check.isAcceptTnC === false
            // check.isIndianCitizen == false ||
            // check.isNotPoliticallyExposed == false ||
            // user.incomeSlab == '' ||
            // user.fatherName == '' ||
            // user.motherName == '' 
          }
          style={{ fontFamily: "Plus Jakarta Sans", fontWeight: "100" }}
          onClick={savetUserData}
          label={update ? update : "Proceed with Same Details"}
          className="p-button-raised mr-3 mt-3 p-button-sm smc_color"
        />
      </Card>
    </>
  );
};

export default PersonalDetails;
